<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="appStore.sidebar.opened" class="hamburger-container"
      @toggleClick="toggleSideBar" />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!settingsStore.topNav" />
    <top-nav id="topmenu-container" class="topmenu-container" v-if="settingsStore.topNav" />
    <!-- jxxmb  fxz-->
    <div class="right-menu">
      <el-button v-hasPermi="['system:create:message']" style="margin-top: 12px" type="primary" size="small" @click="createMessage">创建消息</el-button>
      <div v-if="userStore.roles.includes('fxz') || userStore.roles.includes('xyfwls')" class="status-container">
        <div :class="diffVisited >= 0 ? 'excess-color' : 'shortfall-color'" style="margin-right: 20px;"
          @click="toIntentionStudentList">{{ diffVisitedContent() }}</div>
        <div class="status-container" @click="changeStatus">
          <div style="font-size: 14px;font-weight: 600;">在线状态：</div>
          <div class="lock-container">
            <div :class="onLineStatus === '0' ? 'status-online' : 'status-offline'"></div>
            <div v-if="lockTypeStatus === 1" class="lock-icon">
              <SvgIcon iconClass="lockBlod" />
            </div>
          </div>
        </div>
      </div>
      <template v-if="appStore.device !== 'mobile'">
          <el-button
              type="primary"
              style="margin-top: 12px;margin-right: 5px;"
              size="small"
              @click="microVis = true"
          >外呼设备检测</el-button>
        <!-- <header-search id="header-search" class="right-menu-item" /> -->

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>
        <div v-hasPermi="['system:top:hide-userInfo']">
            <el-tooltip :content="showUserInfo ? '隐藏用户信息' : '展开用户信息'" effect="dark" placement="bottom">
              <div class="right-menu-item hover-effect" @click="showUserInfo = !showUserInfo">
                <el-icon color="#3F8DFD" v-if="!showUserInfo"><View /></el-icon>
                <el-icon color="#3F8DFD" v-else><Hide /></el-icon>
              </div>
            </el-tooltip>
        </div>
      </template>
      <div class="avatar-container">
        <el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img :src="userStore.avatar" class="user-avatar" />
            <div class="name-role" v-if="showUserInfo">
              <span>{{ userStore.userInfo.displayName }}</span>
              <template v-for="(item, index) in roleArr" :key="index">
                <span class="dot"></span>
                <span>{{ item }}</span>
              </template>
            </div>
            <el-icon><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <!-- <el-dropdown-item command="setLayout">
                <span>布局设置</span>
              </el-dropdown-item> -->
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

      <check-microphone-dialog
          v-model:visible="microVis"/>

  </div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import HeaderSearch from '@/components/HeaderSearch'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import { getUserStatus, checkUserStatus } from '@/api/navbar'
import { h } from 'vue'
import CheckMicrophoneDialog from "./CheckMicrophoneDialog.vue";

const appStore = useAppStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()

const onLineStatus = ref()
const lockTypeStatus = ref()
const diffVisited = ref()
const showUserInfo = ref(true)
function createMessage() {
  emits('createMessage')
}

function diffVisitedContent() {
  if (diffVisited.value > 0) {
    return "今日回访人数：超额 " + diffVisited.value
  } else if (diffVisited.value < 0) {
    return "今日回访人数：差额 " + diffVisited.value
  } else {
    return "今日回访人数：0"
  }
}

function userStatus() {
  getUserStatus().then(res => {
    if (res.code === 200) {
      onLineStatus.value = res.data.onlineStatus
      lockTypeStatus.value = res.data.lockType
      diffVisited.value = res.data.diffVisited
    }
  })
}

userStatus()

const changeStatus = () => {
  ElMessageBox(
    {
      message: lockTypeStatus.value === 1
      ?
      h('div',null,[
        h('span',null,'此状态为锁定状态，'),
        h('br',null),
        h('span',null,'锁定状态无法切换。')
      ])
      :
      h('div', null, [
        h('div', {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, [
          h('span', null, '是否切换成'),
          h('div', {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }, [
            h('span', null, '是否切换成'),
            h('div', {
              style: {
                width: '25px',
                height: '25px',
                marginLeft: '10px',
                marginRight: '10px',
                backgroundColor: onLineStatus.value === '0' ? '#FF201F' : '#41CB46',
                borderRadius: '50%'
              }
            }),
            h('span', null, '状态？')
          ]),
          h('span', null, '此状态为' + (onLineStatus.value === '0' ? '无法' : '继续') + '接单状态。')
        ]),
      ]),
      showCancelButton: lockTypeStatus.value === 0,
      confirmButtonText: lockTypeStatus.value === 1 ? '好的' : '是',
      cancelButtonText: '否',
      type: 'info',
      center: true,
    }
  )
    .then(() => {
      if (lockTypeStatus.value !== 1) {
        checkUserStatus({
          aimStatus: onLineStatus.value === '0' ? '1' : '0',
          userId: userStore.userInfo.userId,
          school: userStore.userInfo.schoolId
        }).then(res => {
          if (res.code === 200) {
            userStatus()
          }
        })
      }
    })
    .catch(() => {

    })
}

function toggleSideBar() {
  appStore.toggleSideBar()
}
const roleArr = computed(() => {
  let arr = []
  if (userStore.userInfo.roles && userStore.userInfo.roles.length > 0) {
    userStore.userInfo.roles.forEach(item => {
      arr.push(item.roleName)
    })
  }
  return arr
})
function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
  ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    userStore.logOut().then(() => {
      // 清除token后 刷新页面后 使用permission控制
      location.reload();
    })
  }).catch(() => { });
}

const emits = defineEmits(['setLayout', 'createMessage'])
function setLayout() {
  emits('setLayout');
}

const router = useRouter();
function toIntentionStudentList() {
  router.push({
    path: "/studentmange/intention",
    query: {
      key: 'init',
      ownerid: userStore.userInfo.userName,
      schoolIds: userStore.userInfo.schoolId
    },
  });
}

const microVis = ref(false)
</script>

<style lang='scss' scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    .message-container {
      display: flex;
      align-items: center;
      line-height: 50px;
      padding-right: 10px;
    }

    .status-container {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .excess-color {
        color: #000000;
      }

      .shortfall-color {
        color: #FF201F;
      }

      .lock-container {
        position: relative;
        width: 25px;
        height: 25px;
        margin-left: 15px;
      }

      .status-online {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #41CB46;
        border-radius: 50%;
        z-index: 1;
      }

      .status-offline {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #FF201F;
        border-radius: 50%;
        z-index: 1;
      }

      .lock-icon {
        position: absolute;
        color: #ffffff;
        font-size: 15px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // .status-lock {
      //   width: 25px;
      //   height: 25px;
      //   margin-left: 15px;
      //   background-color: #F7A934;
      //   border-radius: 50%;
      // }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: flex;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      align-items: center;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;

        .name-role {
          font-size: 14px;
          margin: 0 0 0 6px;
          display: flex;
          align-items: center;
          font-weight: bold;

          .dot {
            display: block;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background-color: rgb(77, 75, 75);
            margin: 0 3px;
          }
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
